module.exports = {
    TEACHING: {
        key: 'TEACHING',
        title: 'Teaching',
        description: 'Teaching',
        NavIcon: 'School'
    }
}
